// Module
var code = "<div class=\"body sign-in\"> <header-error/> <router-view/> <loading/> </div> ";
// Exports
export default code;